import { render } from "./FemaleRelatedQuestions.vue?vue&type=template&id=38364b18&scoped=true"
import script from "./FemaleRelatedQuestions.vue?vue&type=script&lang=js"
export * from "./FemaleRelatedQuestions.vue?vue&type=script&lang=js"

import "./FemaleRelatedQuestions.vue?vue&type=style&index=0&id=38364b18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38364b18"]])

export default __exports__